import {CHAT_API_URL} from "../../../constants/api";

export const CHAT_TOKEN_URL = `${CHAT_API_URL}/v1/video/secret`;
